import React, {Component} from 'react';

class PaginationBuilder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentPage:1
		};
	}

	renderLinks = (totalPages, offset) => {
		var items = [];
		if(totalPages <= this.props.pageRangeDisplayed) {
			for(var i=1; i <= totalPages; i++) {
				if(this.state.currentPage === i) {
					items.push(
						<li key={i} className="page-item active paginationItem">
							<span className="page-link">{i}
								<span className="sr-only">
									(current)
								</span>
							</span>
						</li>
					);
				} else {
					items.push(
						<li key={i} className="page-item paginationItem">
							<a 
								onClick={this.onPageClick} 
								id={i} 
								className="page-link"
								/*href="#/myApps"*/
							>
								{i}
							</a>
						</li>
					);
				}
			}
		} else {
			var startPage = 1;
			if((this.state.currentPage-offset) >= 1) {
				startPage = this.state.currentPage-offset;
			}

			var endPage = this.state.currentPage + offset;
			if(endPage > totalPages) {
				endPage = totalPages;
				startPage = endPage - this.props.pageRangeDisplayed +1;
			} else if((endPage - startPage) < this.props.pageRangeDisplayed){
				endPage = startPage + this.props.pageRangeDisplayed -1;
			}
			for(i = startPage; i <= endPage; i++) {
				if(this.state.currentPage === i) {
					items.push(
						<li key={i} className="page-item active">
							<span className="page-link">{i}
								<span className="sr-only">
									(current)
								</span>
							</span>
						</li>
					);
				} else {
					items.push(
						<li key={i} className="page-item">
							<a 
								onClick={this.onPageClick} 
								id={i} 
								className="page-link" 
								/*href="#/myApps"*/
							>
								{i}
							</a>
						</li>
					);
				}
			}
		}

		return items;
	}

	onPageClick = event => {
		var pageNo = parseInt(event.currentTarget.id, 10);
		this.setState({currentPage: pageNo});
		this.processPageDisplay(pageNo);
	}

	processPageDisplay(pageNo) {
		if(this.props.serverSidePagination === true) {
			this.props.refreshPage(pageNo);
		} else {
			var lastItemToShow = this.props.itemsPerPage * pageNo;
	
			var rangeStart = (lastItemToShow-this.props.itemsPerPage);
	
			var pageItems;
	
			if(this.props.totalItems >= lastItemToShow) {
				pageItems = this.props.items.slice(rangeStart, (rangeStart + this.props.itemsPerPage));
			} else {
				pageItems = this.props.items.slice(rangeStart, (this.props.totalItems));
			}
	
			this.props.refreshPage(pageNo, pageItems);
		}
	}

	render() {
		if (this.props.totalItems > this.props.itemsPerPage) {
			var totalPages = (this.props.totalItems / this.props.itemsPerPage);
			totalPages = Math.ceil(totalPages);

			var offset = (this.props.pageRangeDisplayed / 2);
			offset = Math.floor(offset);

		    let prev='';
		    let next='';

	    	if(this.state.currentPage === 1) {
	    		prev =
				<li className="page-item disabled">
					<a className="page-link leftPaginationItem" href={this.props.href}>
						<i className="fa fa-chevron-left"></i>
					</a>
				</li>;
	    	} else {
	    		prev =
				<li className="page-item">
					<a 
						onClick={this.onPageClick} 
						id={(this.state.currentPage-1)} 
						className="page-link leftPaginationItem" 
						href={this.props.href}
					>
						<i className="fa fa-chevron-left"></i>
					</a>
				</li>;
	    	}

	    	if(this.state.currentPage === totalPages) {
	    		next =
				<li className="page-item disabled">
					<a className="page-link rightPaginationItem" href={this.props.href}>
						<i className="fa fa-chevron-right"></i>
					</a>
				</li>;
	    	} else {
	    		next =
				<li className="page-item">
					<a 
						onClick={this.onPageClick} 
						id={(this.state.currentPage+1)} 
						className="page-link rightPaginationItem" 
						href={this.props.href}
					>
						<i className="fa fa-chevron-right"></i>
					</a>
				</li>;
	    	}

			return (
			    <div className="container-fluid">
					<div className="row padBoth padBottom">
						<div className="col-12 bg-white paginationWrapper">
							<nav aria-label="Pagination" className="text-center">
								<ul key="paginationContainer" className="pagination pagination-lg">
									{prev}
									{this.renderLinks(totalPages, offset)}
									{next}
								</ul>
							</nav>
						</div>
					</div>
			   </div>
		   );
		} else {
			return null;
		}

	}
}

export default PaginationBuilder;



// WEBPACK FOOTER //
// ./src/common/PaginationBuilder.js